import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import graphqlClient from "@/GQLClient";
import {
  GetPictogramsDocument,
  SavePictogramDocument,
  type PictogramInput,
} from "@/graphql/generated-types";

const getAll = async () => {
  const response = await graphqlClient.query({
    query: GetPictogramsDocument,
  });

  if (response.data.pictograms) {
    return response.data.pictograms;
  }

  throw new SentryGraphQLError("pictograms.getAll");
};

const save = async (pictogram: PictogramInput) => {
  const response = await graphqlClient.mutate({
    mutation: SavePictogramDocument,
    variables: {
      pictogram,
    },
  });

  if (response.data?.resource?.savePictogram?.success) {
    return response.data.resource.savePictogram;
  }

  throw new SentryGraphQLError("pictograms.save");
};

export default {
  getAll,
  save,
};
